<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear contrato</h2></v-toolbar-title></pre>
                    </v-toolbar>

                    <v-form ref="form" class="mt-3">
                        <v-col cols="12">
                            <router-link to="lista-contrato">
                                <v-btn color="red" class="white--text" s>
                                    Volver
                                </v-btn>
                            </router-link>
                        </v-col>
                        <h2>Datos de contrato</h2>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    @update:search-input="SearchCliente"
                                    v-model="contrato.id_cliente"
                                    :items="clientes"
                                    item-text="razon_social"
                                    item-value="id"
                                    label="Cliente"
                                    :rules="required_val"
                                >
                                    <template v-slot:append-item>
                                        <div v-intersect="endIntersect" />
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <date-select
                                    v-model="contrato.fecha"
                                    label="Fecha"
                                    :rules="required_val"
                                >
                                </date-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div style="display: flex">
                                    <v-autocomplete
                                        v-model="contrato.iva"
                                        type="text"
                                        label="IVA"
                                        :items="ivas"
                                        suffix="%"
                                    >
                                    </v-autocomplete>
                                </div>
                            </v-col>
                            <v-col cols="6" md="6">
                                <v-autocomplete
                                    label="Estado del contrato"
                                    v-model="contrato.id_estado"
                                    :items="estados_contrato"
                                    item-text="nombre"
                                    item-value="id"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                                <div style="display: flex">
                                    <v-autocomplete
                                        v-model="contrato.id_sociedad"
                                        label="Sociedad"
                                        :items="sociedades"
                                        item-text="nombre"
                                        item-value="id"
                                        :rules="required_val"
                                    >
                                    </v-autocomplete>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="contrato.observaciones"
                                    label="Obersevaciones"
                                    outlined
                                >
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <h2>Datos de línea</h2>
                        <v-row>
                            <v-col cols="12">
                                <div style="display: flex">
                                    <v-autocomplete
                                        v-if="linea.tipo_prod == 0"
                                        v-model="linea.id_producto"
                                        :items="productos"
                                        item-text="titulo"
                                        item-value="id"
                                        label="Producto"
                                    >
                                    </v-autocomplete>
                                    <v-text-field
                                        v-else
                                        v-model="linea.producto"
                                        type="text"
                                        label="Producto"
                                    >
                                    </v-text-field>
                                    <v-btn-toggle
                                        color="primary"
                                        style="height: 1rem"
                                        shaped
                                        v-model="linea.tipo_prod"
                                        background-color="white"
                                    >
                                        <v-btn text> Existente </v-btn>
                                        <v-btn text> Nuevo </v-btn>
                                    </v-btn-toggle>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="spacing">
                                    <v-text-field-comma
                                        v-model="linea.cantidad"
                                        type="number"
                                        label="Cantidad"
                                    >
                                    </v-text-field-comma>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="spacing">
                                    <v-text-field-comma
                                        v-model="linea.precio"
                                        type="number"
                                        label="Precio"
                                    >
                                    </v-text-field-comma>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div style="display: flex">
                                    <v-text-field-comma
                                        v-model="linea.dcto"
                                        type="number"
                                        label="Descuento"
                                    >
                                    </v-text-field-comma>
                                    <v-btn-toggle
                                        color="primary"
                                        shaped
                                        v-model="linea.id_tipo_dcto"
                                        background-color="white"
                                    >
                                        <v-btn text>
                                            <v-icon>mdi-percent</v-icon>
                                        </v-btn>
                                        <v-btn text>
                                            <v-icon>mdi-currency-eur</v-icon>
                                        </v-btn>
                                    </v-btn-toggle>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-btn
                                    @click="addLinea"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Añadir</v-btn
                                >
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    dense
                                    :headers="headers"
                                    hide-default-footer
                                    :items="contrato.lineas"
                                    item-key="id"
                                    class="elevation-1"
                                >
                                    <template v-slot:item.cantidad="{ item }">
                                        {{ formatNumber(item.cantidad) }}
                                    </template>
                                    <template v-slot:item.precio="{ item }">
                                        {{ item.precio | format_precio }}
                                    </template>
                                    <template v-slot:item.dcto="{ item }">
                                        {{ item.dcto | format_precio }}
                                    </template>
                                    <template v-slot:item.total="{ item }">
                                        {{ item.total | format_precio }}
                                    </template>
                                    <template v-slot:item.dcto_total="{ item }">
                                        {{
                                            CalcularTotalDcto(item)
                                                | format_precio
                                        }}
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <v-icon
                                            @click="openEditDialog(item)"
                                            small
                                            class="mr-2"
                                            color="black"
                                            style="font-size: 25px"
                                            title="EDITAR"
                                            >mdi-pencil-outline</v-icon
                                        >

                                        <v-icon
                                            @click="openDeleteDialog(item)"
                                            small
                                            class="mr-2"
                                            color="red"
                                            style="font-size: 25px"
                                            title="BORRAR"
                                            >mdi-trash-can</v-icon
                                        >
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-row align="start" justify="end">
                            <v-col cols="12" md="4">
                                <div style="display: flex">
                                    <v-text-field
                                        v-model="contrato.dcto"
                                        type="number"
                                        label="Descuento"
                                    >
                                    </v-text-field>
                                    <v-btn-toggle
                                        color="primary"
                                        shaped
                                        v-model="contrato.id_tipo_dcto"
                                        background-color="white"
                                    >
                                        <v-btn text>
                                            <v-icon>mdi-percent</v-icon>
                                        </v-btn>
                                        <v-btn text>
                                            <v-icon>mdi-currency-eur</v-icon>
                                        </v-btn>
                                    </v-btn-toggle>
                                </div>
                            </v-col>
                            <v-col cols="4"> </v-col>
                            <v-col cols="12" md="4">
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <v-row>
                                        <v-col cols="6">
                                            <h4>Subtotal:</h4>
                                        </v-col>
                                        <v-col cols="6">
                                            <h4>
                                                {{
                                                    formatNumber(
                                                        calcularSubTotal()
                                                    )
                                                }}
                                                €
                                            </h4>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <h4>Descuento:</h4>
                                        </v-col>
                                        <v-col cols="6">
                                            <h4>
                                                -
                                                {{
                                                    formatNumber(
                                                        CalculateDescuento(
                                                            contrato.subtotal
                                                        )
                                                    )
                                                }}
                                                €
                                            </h4>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="contrato.iva != 0">
                                        <v-col cols="6">
                                            <h4>IVA:</h4>
                                        </v-col>
                                        <v-col cols="6">
                                            <h4>
                                                {{
                                                    formatNumber(
                                                        calcularSubTotal() *
                                                            (Number.parseFloat(
                                                                contrato.iva.toString()
                                                            ) /
                                                                100)
                                                    )
                                                }}
                                                €
                                            </h4>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <h4>Total:</h4>
                                        </v-col>
                                        <v-col cols="6">
                                            <h4>
                                                {{
                                                    formatNumber(contrato.total)
                                                }}
                                                €
                                            </h4>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="4">
                                <v-autocomplete
                                    label="Método de pago"
                                    v-model="contrato.id_metodo_pago"
                                    :items="metodos_pago"
                                    item-text="nombre"
                                    item-value="id"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="6" md="4">
                                <v-text-field
                                    label="Detalles del método de pago"
                                    v-model="detalles_metodo_pago"
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-contrato">
                                    <v-btn color="red" class="white--text">
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!contrato.id"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    @click="saveContrato"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    @click="updateContrato"
                                    v-if="contrato.id"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Actualizar</v-btn
                                >
                                <router-link
                                    :to="{
                                        path: `ver-planificacion?id=${contrato.id}`,
                                    }"
                                    class="action-buttons"
                                >
                                    <v-btn
                                        v-if="contrato.id"
                                        :disabled="isloading"
                                        color="primary"
                                        class="white--text"
                                        >Crear planificación</v-btn
                                    >
                                </router-link>
                                <template v-if="contrato.id">
                                    <a
                                        target="_blank"
                                        :href="`/api/pdf-contrato/${contrato.id}`"
                                    >
                                        <v-btn
                                            :disabled="isloading"
                                            color="info"
                                            class="white--text"
                                            >PDF</v-btn
                                        >
                                    </a>
                                    <v-btn
                                        v-if="
                                            (contrato.revisado == 0) &
                                            (rol != 4) &
                                            (rol != 5)
                                        "
                                        :disabled="isloading"
                                        color="primary"
                                        class="white--text"
                                        @click="Validar"
                                        >Validar</v-btn
                                    >
                                    <v-btn
                                        v-if="contrato.revisado == 1"
                                        @click="openEmailDialog"
                                        :disabled="isloading"
                                        color="secondary"
                                        class="white--text"
                                        >Enviar PDF</v-btn
                                    >

                                    <v-btn
                                        @click="deleteContrato"
                                        :disabled="isloading"
                                        color="red"
                                        class="white--text"
                                        >Eliminar</v-btn
                                    >
                                </template>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog v-model="email_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Email
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>Indique el email a enviar</h2>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="email"
                                type="email"
                                label="Email"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="email_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="sendEmail()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--edit dialog-->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Editar línea
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <div style="display: flex">
                                <v-autocomplete
                                    v-if="editlinea.tipo_prod == 0"
                                    v-model="editlinea.id_producto"
                                    :items="productos"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Producto"
                                >
                                </v-autocomplete>
                                <v-text-field
                                    v-else
                                    v-model="editlinea.producto"
                                    type="text"
                                    label="Producto"
                                >
                                </v-text-field>
                                <v-btn-toggle
                                    color="primary"
                                    style="height: 1rem"
                                    shaped
                                    v-model="editlinea.tipo_prod"
                                    background-color="white"
                                >
                                    <v-btn text> Existente </v-btn>
                                    <v-btn text> Nuevo </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.cantidad"
                                    type="number"
                                    label="Cantidad"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.precio"
                                    type="number"
                                    label="Precio"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div style="display: flex">
                                <v-text-field-comma
                                    v-model="editlinea.dcto"
                                    type="number"
                                    label="Descuento"
                                >
                                </v-text-field-comma>
                                <v-btn-toggle
                                    color="primary"
                                    shaped
                                    v-model="editlinea.id_tipo_dcto"
                                    background-color="white"
                                >
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="Edit()"
                        >Modificar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--delete dialog-->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="delete_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteLinea()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { debounce } from "../../../helpers";

export default {
    data() {
        return {
            required_val: [
                (v) => !!v || "El campo es requerido",
                (v) => v != "" || "El campo es requerido",
            ],
            sociedades: [],

            ivas: [21, 10, 4],
            metodos_pago: [],
            detalles_metodo_pago: "",
            email_dialog: false,
            email: "",
            rol: 0,
            headers: [
                { text: "Producto", value: "producto", sortable: false },
                { text: "Cantidad", value: "cantidad", sortable: false },
                { text: "Precio", value: "precio", sortable: false },
                { text: "Descuento", value: "dcto_total", sortable: false },
                { text: "Total", value: "total", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            enable_iva: false,
            // clientes: [],
            productos: [],

            contrato: {
                id: null,
                fecha: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                )
                    .toISOString()
                    .substr(0, 10),
                revisado: false,
                id_metodo_pago: null,
                id: null,
                id_cliente: null,
                iva: 21,
                subtotal: 0,

                dcto: 0,
                id_tipo_dcto: 0,
                total: 0,
                lineas: [],
                lineas_deleted: [],
                id_estado: 1,
            },
            delete_dialog: false,
            linea: {
                id: null,
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
            },
            editlinea: {
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
            },
            dialog: false,
            init_edit: false,
            edit_index: -1,
        };
    },
    watch: {
        enable_iva: function (val) {
            if (!val) {
                this.contrato.iva = 0;
            }

            this.calcularTotalmax();
        },
        "contrato.id_tipo_dcto": function () {
            this.calcularTotalmax();
        },
        "contrato.id_metodo_pago": function (id) {
            this.getDetallesMetodoPago(id);
        },
        "contrato.id_cliente": function (id) {
            let cliente = this.clientes.find((element) => element.id == id);
            /////console.log(cliente);
            this.metodos_pago = cliente.metodos_pago;
            let met_temp = this.metodos_pago.find(
                (element) => element.predeterminado == 1
            );
            if (met_temp) {
                this.contrato.id_metodo_pago = met_temp.id;
            }
            this.getDetallesMetodoPago(this.contrato.id_metodo_pago);
        },
        "contrato.iva": function (iva) {
            this.calcularTotalmax();
        },
        "linea.id_producto": function (val) {
            this.productos.forEach((element) => {
                if (element.id == val) {
                    this.linea.producto = element.nombre.toString();
                    this.linea.precio = element.precio;
                }
            });
            /////console.log(this.linea);
        },
        "contrato.dcto": function () {
            this.calcularTotalmax();
        },
        "editlinea.id_producto": function (val) {
            this.productos.forEach((element) => {
                if ((element.id == val) & !this.init_edit) {
                    this.editlinea.producto = element.nombre.toString();
                    this.editlinea.precio = element.precio;
                }
                this.init_edit = false;
            });
            /////console.log(this.linea);
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
        nacimiento(val) {
            this.nacimientoesp = this.formatDate(this.nacimiento);
            this.cliente.nacimiento = this.nacimiento;
        },
        fecha_alta(val) {
            /*this.fecha_altaesp = this.formatDate(this.fecha_alta);
            this.cliente.fecha_alta = this.fecha_alta;*/
        },
    },
    created() {
        this.rol = localStorage.getItem("role");
        this.getEstadosContrato();
        this.getProductos();
        this.getSociedades();

        if (this.$route.query.id) {
            this.getContrato(this.$route.query.id);
        } else {
            this.$store.dispatch("getClientes", this);
        }

        // this.getClientes();
    },
    methods: {
        getSociedades() {
            axios.get("api/get-sociedades").then((res) => {
                this.sociedades = res.data;
            });
        },
        Validar() {
            axios
                .post("api/validate-contrato", { id: this.$route.query.id })
                .then((res) => {
                    this.$router.go();
                });
        },
        getEstadosContrato() {
            axios.get("api/get-estados-contrato").then((res) => {
                this.estados_contrato = res.data;
            });
        },
        SearchCliente: debounce(function (val) {
            this.$store.dispatch("searchCliente", val);
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getClientesNext", this);
            }
        },
        getDetallesMetodoPago(id) {
            this.metodos_pago.forEach((element) => {
                if (element.id == id) {
                    /////console.log(element);
                    this.detalles_metodo_pago = element.valor;
                }
            });
        },
        sendEmail() {
            axios
                .post(`api/sendEmailContrato`, {
                    email: this.email,
                    id: this.contrato.id,
                })
                .then(
                    (res) => {},
                    (res) => {}
                );
        },
        CalcularTotalDcto(item) {
            return item.precio * item.cantidad - item.total;
        },
        openEmailDialog() {
            this.email_dialog = true;
        },
        closeEmailDialog() {
            this.email_dialog = false;
        },
        formatNumber(number) {
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },

        getContrato(id) {
            axios.get(`api/getcontrato/${id}`).then(
                (res) => {
                    this.contrato = res.data;
                    this.contrato.lineas_deleted = [];
                    let found = false;
                    if (this.contrato.cliente != null) {
                        if (this.contrato.cliente.length > 0) {
                            /////console.log(this.contrato.cliente);
                            this.email = this.contrato.cliente[0].email;
                            found = true;
                            this.$store.dispatch("getClientesWithId", {
                                id: this.contrato.cliente[0].id_cliente,
                            });
                        }
                    }
                    if (!found) {
                        this.$store.dispatch("getClientes", this);
                    }
                    if (Number.parseFloat(this.contrato.iva.toString()) != 0) {
                        this.enable_iva = true;
                    }
                },
                (res) => {}
            );
        },
        closeDialog() {
            this.delete_dialog = false;
            this.dialog = false;
        },
        openEditDialog(item) {
            this.dialog = true;
            this.editlinea = JSON.parse(JSON.stringify(item));
            /////console.log("edit");
            /////console.log(this.editlinea);
            this.init_edit = true;
            this.edit_index = this.contrato.lineas.indexOf(item);
        },
        Edit() {
            let items = JSON.parse(JSON.stringify(this.editlinea));
            let index1 = this.contrato.lineas[this.edit_index];
            index1.id_producto = items.id_producto;
            index1.producto = items.producto;
            index1.cantidad = items.cantidad;
            index1.precio = items.precio;
            index1.id_tipo_dcto = items.id_tipo_dcto;
            index1.dcto = items.dcto;
            index1.total = items.total;
            index1.tipo_prod = items.tipo_prod;
            this.calcularTotal(index1);
            /////console.log(this.contrato.lineas);
            this.editlinea = {
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
            };
            this.closeDialog();
            this.calcularTotalmax();
        },
        calcularSubTotal() {
            let total = 0;
            this.contrato.lineas.forEach((element) => {
                total += +element.total;
            });
            return total;
        },
        calcularTotalmax() {
            this.contrato.total =
                (this.calcularSubTotal() - this.CalculateDescuento()) *
                (1 + this.contrato.iva / 100);
        },
        openDeleteDialog(item) {
            /////console.log(item);
            this.editlinea = item;
            this.delete_dialog = true;
        },
        deleteLinea() {
            let index = this.contrato.lineas.indexOf(this.editlinea);
            if (this.editlinea.id != null) {
                this.contrato.lineas_deleted.push(this.editlinea.id);
            }
            this.contrato.lineas.splice(index, 1);
            this.delete_dialog = false;
            this.calcularTotalmax();
        },
        addLinea() {
            this.calcularTotal(this.linea);
            this.contrato.lineas.push(this.linea);
            /////console.log(this.contrato.lineas);
            this.emptyLinea();
            this.calcularTotalmax();
        },
        calcularTotal(linea) {
            linea.total = linea.precio * linea.cantidad;
            if (linea.id_tipo_dcto == 0) {
                linea.total *= 1 - linea.dcto / 100;
            } else if (linea.total > linea.dcto) {
                linea.total -= linea.dcto;
            } else {
                linea.total = 0;
            }
            linea.total = linea.total.toFixed(2);
        },
        emptyLinea() {
            this.linea = {
                id: null,
                id_producto: null,
                producto: "",
                cantidad: 0,
                precio: 0,
                id_tipo_dcto: 0,
                dcto: 0,
                total: 0,
                tipo_prod: 0,
            };
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },

        /*getClientes() {
            axios.get(`api/get-clientes/-1`).then(
                (res) => {
                    this.clientes = res.data.Clientes;
                },
                (res) => {}
            );
        },*/
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.agentes = res.data.Agentes;
                },
                (res) => {}
            );
        },
        saveContrato() {
            if (!this.$refs.form.validate()) {
                this.$custom_error("Debe llenar los campos requeridos");
                return;
            }
            axios
                .post("api/save-contrato", this.contrato)
                .then((res) => {
                    this.$router.push("lista-contrato");
                })
                .catch((error) => {
                    /////console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deleteContrato() {
            axios.post("api/delete-contrato", { id: this.contrato.id }).then(
                (res) => {
                    this.$toast.sucs("Contrato eliminado con éxito");
                    this.$router.push("lista-contrato");
                },
                (err) => {
                    this.$custom_error("Error eliminando el contrato");
                }
            );
            this.getContratos();
        },
        updateContrato() {
            if (!this.$refs.form.validate()) {
                this.$custom_error("Debe llenar los campos requeridos");
                return;
            }
            axios
                .post("api/update-contrato", this.contrato)
                .then((res) => {
                    this.$router.push("lista-contrato");
                })
                .catch((error) => {
                    /////console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        CalculateDescuento() {
            if (this.contrato.id_tipo_dcto == 1) {
                return this.contrato.dcto;
            } else {
                return this.calcularSubTotal() * (this.contrato.dcto / 100);
            }
        },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
        clientes() {
            /////console.log("siva");
            let clientes_temp = this.$store.getters.getclientes;

            return clientes_temp;
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
.spacing {
    padding-top: 0 !important;
}
</style>
